import LoopFront, { TAction } from "loop-front";
import { ThunkAction } from "redux-thunk";
import { ReduxStore } from "../../stores";
import utilities from "../../Resources/Utils";

const CustomActions = {
    APP_USER_RECEIVED: 'APP_USER_RECEIVED'
}

const CustomEntities = {
    USER_COMMENTS: 'comments'
}

const CustomActivities = {
    LOGIN: 'login',
    LOGOUT: 'logout',
    TOGGLE_PUBLISH: 'publish',
}

class User extends LoopFront<typeof CustomActions, typeof CustomEntities, typeof CustomActivities>{
    constructor() {
        super('users', CustomActions, CustomEntities, CustomActivities);
    }

    logout = (): ThunkAction<void, ReduxStore, {}, TAction> => async (dispatch, getState) => {
        utilities.clearCookies();
        await this.requestPostActivity(this.Activities.LOGOUT).catch(error => { });
        dispatch({ type: this.Actions.ACTIVITY_POST_SUCCESS, activity: this.Activities.LOGOUT });
        LoopFront.setAuthHeader('');

    }

}

export const OUser = new User();